module.exports = __webpack_public_path__ + "img/navCards_fzlc.4ce1634f.png";